import { render, staticRenderFns } from "./user-deletion-modal.vue?vue&type=template&id=4b601e20&scoped=true"
import script from "./user-deletion-modal.vue?vue&type=script&lang=js"
export * from "./user-deletion-modal.vue?vue&type=script&lang=js"
import style0 from "./user-deletion-modal.vue?vue&type=style&index=0&id=4b601e20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b601e20",
  null
  
)

export default component.exports